/** Keep the user's work position across a saved immutable PDF reload. */
export function capturePdfEditorView(application, editor) {
    const viewer=application.pdfViewer;
    return {editor:editor.editingState(),page:application.pagePosition?.(viewer.currentPageNumber) || viewer.currentPageNumber,
        rotation:viewer.pagesRotation,scale:viewer.currentScaleValue || viewer.currentScale,thumbnails:application.thumbnailsVisible,
        scrollTop:viewer.container?.scrollTop || 0,scrollLeft:viewer.container?.scrollLeft || 0};
}

export function restorePdfEditorView(application, state) {
    if(!state)return;
    const viewer=application.pdfViewer;
    if(typeof state.thumbnails==='boolean')application.toggleThumbnails?.(state.thumbnails);
    if([0,90,180,270].includes(state.rotation))viewer.pagesRotation=state.rotation;
    if(Number.isInteger(state.page) && state.page >= 1 && state.page <= application.pdfDocument.numPages)viewer.currentPageNumber=state.page;
    if(['page-fit','page-width','auto'].includes(state.scale) || Number(state.scale)>0)viewer.currentScaleValue=state.scale;
}
